import PropTypes from 'prop-types'
import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

export const extractionStatuses = {
  NOT_STARTED: 0,
  REQUESTED: 1,
  COMPLETED: 2,
  FAILED: -1,
}

const useStyles = createUseStyles({
  parseIcon: {
    justifyContent: 'center',
    borderRadius: 50,
    padding: '5px',
    marginRight: '5px',
    width: '1px',
  },
  parseRequested: {
    backgroundColor: 'orange',
  },
  parseCompleted: {
    backgroundColor: 'green',
  },
  parseFailed: {
    backgroundColor: 'red',
  },
  parseNotStarted: {
    backgroundColor: 'gray',
  },
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  label: {
    paddingRight: '1rem',
  },
})

export default function DataExtractionIcon({
  extractionStatus,
  showLabel = true,
}) {
  const theme = useTheme()
  const classes = useStyles({ theme })

  let statusClass
  let label

  switch (extractionStatus) {
    case extractionStatuses.NOT_STARTED:
      statusClass = classes.parseNotStarted
      label = 'Not Started'
      break
    case extractionStatuses.REQUESTED:
      statusClass = classes.parseRequested
      label = 'Pending'
      break
    case extractionStatuses.COMPLETED:
      statusClass = classes.parseCompleted
      label = 'Completed'
      break
    case extractionStatuses.FAILED:
      statusClass = classes.parseFailed
      label = 'Failed'
      break
    default:
      label = 'Unknown'
      statusClass = classes.parseNotStarted
  }

  return (
    <div className={classes.iconContainer}>
      <div className={`${statusClass} ${classes.parseIcon}`} />
      {showLabel && <span className={classes.label}>{label}</span>}
    </div>
  )
}

DataExtractionIcon.propTypes = {
  extractionStatus: PropTypes.oneOf(Object.values(extractionStatuses))
    .isRequired,
  showLabel: PropTypes.bool,
}

DataExtractionIcon.defaultProps = {
  showLabel: true,
}
